var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.active)?_c('div',{staticClass:"inactive",on:{"click":_vm.addTag}},[_vm._v("\n    "+_vm._s(_vm.name)+" +\n  ")]):_c('div',{staticClass:"active",on:{"click":_vm.removeTag}},[_vm._v("\n    "+_vm._s(_vm.name)+" "),_c('img',{attrs:{"src":require("../../assets/active-tag.svg"),"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-104506c5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/job-tag.vue
// module id = null
// module chunks = 